import React from 'react';

/**
 * The Entelligence "e" brand mark. Uses currentColor so callers control the
 * color via `text-*`. This is the real logo mark (not a font glyph).
 */
export function EntelligenceMark({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 80.1533 81.4219"
      fill="none"
      className={className}
      aria-hidden
    >
      <path
        d="M16.335 47.9961C19.2683 57.7818 28.0864 65.0224 38.6797 65.6113V81.4219C19.2972 80.7685 3.34872 66.5731 0 47.9961H16.335ZM80.1523 48.001H63.8174C63.8179 47.9993 63.8188 47.9978 63.8193 47.9961H80.1533C80.153 47.9977 80.1526 47.9994 80.1523 48.001ZM63.7305 33.4521C64.464 35.794 64.8604 38.2854 64.8604 40.8691C64.8603 43.3465 64.4959 45.7389 63.8193 47.9961H16.335C15.6584 45.739 15.2949 43.3465 15.2949 40.8691C15.2949 38.2854 15.6903 35.794 16.4238 33.4521H63.7305ZM40.0762 0C60.0852 0 76.7245 14.4307 80.1533 33.4521H63.7305C60.578 23.3885 51.1804 16.0859 40.0771 16.0859C28.974 16.086 19.5763 23.3885 16.4238 33.4521H0C3.42882 14.4308 20.0673 0.000209404 40.0762 0Z"
        fill="currentColor"
      />
    </svg>
  );
}
